<template>

  <div>
    <v-app-bar
    height="auto"
    elevation="3"
    >
    <v-row class="top-facebookicon hidden-sm-and-down">
      <!-- <div><a href='/konniesystem/News/' target="_blank" class="link-button cf-cnt">ニュース</a></div> -->
      <!-- <div>
      <a href="https://www.facebook.com/konniesystem/" target=_blank title="コニーシステムfacebookページへ"><v-icon large color="light-blue darken-3">mdi-facebook</v-icon>
      </a>
      </div> -->
      </v-row>
    <v-layout class="hidden-md-and-up site-logo">
      <router-link to="/">
<span style="font-size:2.2rem; font-family: 'EB Garamond', 'Apple Chancery', 'Monotype Corsiva',serif; color:#C62828; font-style: italic;">K</span><span style="font-size:1.5rem; font-family: 'EB Garamond', 'Apple Chancery', 'Monotype Corsiva',serif; color:navy; font-style: italic;">onniesystem</span>
      </router-link>
      <div>
      <a href="https://www.facebook.com/konniesystem/" target=_blank title="コニーシステムfacebookページへ"><v-icon large color="light-blue darken-3">mdi-facebook</v-icon>
      </a>
      </div>
      </v-layout>
      <!-- <v-layout justify-end  style="color:dark-gray!important;">
      <div class="hidden-xs-only">
      〒770-0936
徳島県徳島市中央通3丁目１番地<br/>
TEL : 088-625-8102<br/>
FAX : 088-625-8104
          <a href="https://www.facebook.com/konniesystem/" target=_blank><v-icon large>mdi-facebook</v-icon></a>
      </div>
     </v-layout> -->
      <!--画面幅が770px以下でハンバーガーメニューを表示-->
      <template v-if="width < '770'">
        <v-app-bar-nav-icon
        @click="drawer = !drawer"
        large>
        </v-app-bar-nav-icon>
      </template>
      <!--画面幅が770px以上でナビゲーションを表示-->
      <template v-slot:extension v-if="width >= '770'">

        <v-tabs
        centered
        slider-color="blue-grey"
        background-color="white"
        class="black--text"
        grow
        icons-and-text
        show-arrows
        >
        <div class="hidden-sm-and-down site-logo">
          <!-- <div>
      <a href="https://www.facebook.com/konniesystem/" target=_blank title="コニーシステムfacebookページへ"><v-icon large color="light-blue darken-3">mdi-facebook</v-icon>
      </a>
      </div> -->
       <router-link to="/">
<span style="font-size:2.2rem; font-family: 'EB Garamond', 'Apple Chancery', 'Monotype Corsiva',serif; color:#C62828; margin-left:1rem; font-style: italic;">K</span><span style="font-size:1.5rem; font-family: 'EB Garamond', 'Apple Chancery', 'Monotype Corsiva',serif; color:navy; font-style: italic;">onniesystem</span>
      </router-link>
      </div>
          <!-- ロゴは別要素として配置 -->
    <!-- <div class="logo hidden-sm-and-down">
      <router-link to="/">
        <span class="logo-k">K</span><span class="logo-text">onniesystem</span>
      </router-link>
    </div> -->
          <v-tab
          v-for="item in pages"
          :key="item.page"
          :to="item.link"
          >
            {{ item.page }}
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      <div>
      <a href="https://www.facebook.com/konniesystem/" target=_blank title="コニーシステムfacebookページへ"><v-icon large color="light-blue darken-3">mdi-facebook</v-icon>
      </a>
      </div>
      </template>
    </v-app-bar>
    <!--ハンバーガーメニューをタップすると右に表示されるナビゲーション-->
    <v-navigation-drawer
      absolute
      temporary
      right
      v-model="drawer"
      color="white"
      class="fomt-weight-medium"
      width="280px"
      id="humNuv"
    >
      <v-list-item two-line>
        <v-icon>
          mdi-home-city
        </v-icon>
        <v-list-item-content class="ml-2">
          <v-list-item-title>有限会社コニーシステム</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider dark></v-divider>
      <v-list dense>
        <v-list-item
          v-for="item in pages"
          :key="item.page"
          :to="item.link"
          v-model="group"
          @click.stop="drawer = false"
        >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
          <v-list-item-content class="py-1">
            <v-list-item-title>{{ item.page }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-3"></v-divider>
        <v-list-item>
          <br><br>
          〒770-0936 徳島県徳島市中央通3丁目１番地<br>
          電話番号  : 088-625-8102<br>
          FAX番号  : 088-625-8104<br>
        </v-list-item>
        <v-list-item>
          <a href="https://www.facebook.com/konniesystem/" target=_blank><v-icon large color="light-blue darken-3">mdi-facebook</v-icon></a>
        </v-list-item>
        <v-list-item>
          <v-spacer></v-spacer>
          <v-btn icon to="https://www.facebook.com/konniesystem/">
            <v-icon large class="mt-5" color="light-blue darken-3">
              mdi-facebook-box
            </v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
      <v-layout justify-center>
         <v-btn
          color="blue-grey"
        outlined
          dark
          @click.stop="drawer = !drawer"
        >
          閉じる
        </v-btn>
        </v-layout>
    </v-navigation-drawer>
  </div>
</template>

<style>
#humNuv {
  z-index: 101;
}

.v-application .v-toolbar__extension {
  height: 64px !important;
}

.v-tabs {
  height: 64px !important;
  min-height: 64px !important;
}
.v-toolbar__extension {
    padding: 20px !important;
}

.top-facebookicon {
  display: flex;
  justify-content: flex-start;
  padding: 0 6%;
}

.site-logo {
  display: flex;
  align-items: center;
  margin-left: 6%;
  text-decoration: none;
}

.v-toolbar__extension {
  padding: 0 6% !important;
}

.v-tabs {
  height: 64px !important;
  min-height: 64px !important;
  align-items: center;
  padding-left: 0 !important;
}

@media screen and (max-width:768px) {
    .site-logo {
     margin-left: 0;
    }
}
</style>

<script>
export default {
  data () {
    return {
      // リサイズイベント用 初期値0
      width: window.innerWidth,
      // ナビゲーションドロワー
      drawer: false,
      group: null,
      // リンク集
      pages: [
        {
          page: 'Home',
          icon: 'mdi-home',
          link: '/'
        },
        {
          page: 'ニュース',
          icon: 'mdi-information',
          link: '/news'
        },
        {
          page: 'サービス',
          icon: 'mdi-ribbon',
          link: '/Service'
        },
        {
          page: '製品案内',
          icon: 'mdi-file-document-outline',
          link: '/Products'
        },
        {
          page: '会社情報',
          icon: 'mdi-home-city',
          link: '/Company'
        },
        {
          page: 'お問い合わせ',
          icon: 'mdi-phone',
          link: '/Contact'
        }
      ]
    }
  },
  methods: {
    // 画面幅を特定
    calculateWindowWidth () {
      this.width = window.innerWidth
    },
    transition (link) {
      this.$router.push(link)
    }
  },
  created () {
    window.addEventListener('resize', this.calculateWindowWidth)
  },
  watch: {
    group () {
      this.drawer = false
    }
  }
}
</script>
